import { WindowLocationService } from '@propertyfinder/pf-frontend-common/src/service/window-location/service';

import { configGetEnv } from 'common/helper/config/get-env';
import { FilterSearchUrlAdapterFactory } from 'common/module/filter/search/url/adapter.factory';
import { SaveSearchListComponentFactory } from 'common/module/save-search/list/component.factory';
import { SaveSearchTrackerFactory } from 'common/module/save-search/tracker.factory';
import { MessageService } from 'common/service/message/service';
import { SaveSearchStoreService } from 'common/service/save-search-store/service';
import { UserAuthenticationService } from 'common/service/user-authentication/service';
import { SaveSearchFormComponent } from 'desktop/module/save-search/form/component';

export const SaveSearchListComponent = SaveSearchListComponentFactory({
  saveSearchStoreService: SaveSearchStoreService(),
  userAuthenticationService: UserAuthenticationService(),
  filterSearchAdapter: FilterSearchUrlAdapterFactory(),
  messageService: MessageService(),
  getSearchUri: () => configGetEnv().userPropertySearchUrl,
  formComponent: SaveSearchFormComponent,
  saveSearchTracker: SaveSearchTrackerFactory(),
  windowLocationService: WindowLocationService(),
});
